export enum Layers {
    Vehicle = 'vehicle',
    VehicleTooltip = 'vehicletooltip',
    VehicleWarning = 'vehiclewarning',
    Stops = 'stops',
    Lines = 'lines',
    DrawRoute = 'drawRoute',
    RouteReference = 'routeReference',
    StopsTileset = 'stopsTileset',
    RouteTileset = 'routetileset',
    TimingPoint = 'timingPoint'
}
